import { Box } from "@mui/material";

import Input from "../../components/controls/Input";

import useStyles from "./profileInformationStyle";
import { useTranslation } from "react-i18next";

import PageTitle from "../../components/pageTitle/PageTitle";

import globalStyles from "../../style/global.js";

function ProfileInformation() {
  const classes = useStyles();
  const globalClasses = globalStyles();

  const { t } = useTranslation();
  return (
    <div >
   
      <div className={globalClasses.form}>
        <Box className={classes.box}>
          <Input
            label={t("firstName")}
            readonly={true}
            value={"hussein"}
            className={globalClasses.filed}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            label={t("lastName")}
            value={"ayyad"}
            readonly={true}
            className={globalClasses.filed}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            label={t("userName")}
            value={"hussein"}
            readonly={true}
            className={globalClasses.filed}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            label={t("email")}
            value={"husseinayyad70@gmail.com"}
            readonly={true}
            className={globalClasses.filed}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            label={t("phone")}
            value={"+962795011274"}
            readonly={true}
            className={globalClasses.filed}
          />
        </Box>
       
      

       
      </div>
    </div>
  );
}

export default ProfileInformation;
